module.exports = __webpack_public_path__ + "static/menuPohrebka-e7f65d553f92f04db640464a79f06e37.svg";